'use strict';

import React from 'react';
import Row from '../tag/Row';
import Span from '../tag/Span';
import ReservationListItem from './ReservationListItem';
import { FormattedMessage } from 'react-intl';

const ReservationList = ({ data, selectAndSubmit }) => {
  return (
    <>
      <Row>
        <Span>
          <ul className="appointment-container">
            {data.map((item) => (
              <ReservationListItem key={item.dateStart} item={item} isShort>
                <button
                  style={{ marginLeft: '10px', float: 'right' }}
                  className="appointment__button"
                  onClick={() => {
                    selectAndSubmit(item);
                  }}
                >
                  <FormattedMessage id={'reserve.appointment'} />
                </button>
              </ReservationListItem>
            ))}
          </ul>
        </Span>
      </Row>
    </>
  );
};

export default ReservationList;
